import React, { useContext } from "react";
import { PermissionContext, RolePermissions } from "appContext";
import { pages } from "../../../common/constant";
import { ReactComponent as Refresh } from "assets/img/svg/Group 29.svg";
import { getScreenCards } from "views/pages/manage/finOps/IssueStock/search/SearchCard.jsx";
import { useHistory } from "react-router";

const ElogisticsLandingPage = () => {
    const history = useHistory();

    const sapPurchaseRequisitionPermission = RolePermissions(
        useContext(PermissionContext),
        pages["sapPurchaseRequisition"]["id"]
    );
        const sapPurchaseRequisitionListingPermission = RolePermissions(
        useContext(PermissionContext),
        pages["sapPurchaseRequisitionListing"]["id"]
    );
        const sapGrnPermission = RolePermissions(
        useContext(PermissionContext),
        pages["sapGrn"]["id"]
    );
        const sapEntrySheetPermission = RolePermissions(
        useContext(PermissionContext),
        pages["sapEntrySheet"]["id"]
    );

    const screens = [
        sapPurchaseRequisitionPermission && {
            heading: "SAP Purchase Requisition",
            subHeading: "Sap purchase Requisition",
            icon: <Refresh />,
            action: () =>
                history.push(
                    "/admin/edp/stockInventoryMaster/sapPurchaseOrder"
                ),
        },
        sapPurchaseRequisitionListingPermission && {
            heading: "SAP Purchase Requisition Listing",
            subHeading: "Sap purchase Requisition Listing",
            icon: <Refresh />,
            action: () =>
                history.push(
                    "/admin/edp/stockInventoryMaster/sapPurchaseOrderListing"
                ),
        },
        sapGrnPermission && {
            heading: "SAP GRN",
            subHeading: "Sap GRN",
            icon: <Refresh />,
            action: () =>
                history.push(
                    "/admin/edp/stockInventoryMaster/sapPurchaseGrn"
                ),
        },
        sapEntrySheetPermission && {
            heading: "SAP Entry Sheet",
            subHeading: "Sap Entry Sheet",
            icon: <Refresh />,
            action: () =>
                history.push(
                    "/admin/edp/stockInventoryMaster/sapServiceEntrySheet"
                ),
        },
    ];

    return <div className={`screen-cards-container`}>
            {getScreenCards(screens?.filter((item) => item))}
        </div>;
};

export default ElogisticsLandingPage;
